import { ProductPriceTicketLine } from 'Components/lines/product-price-ticket-line/ProductPriceTicketLine';
export default ProductPriceTicketLine;
